import { application } from "./application";

import { AttendeeScannerController } from "./scanner/attendee_scanner_controller";

application.register("attendee-scanner", AttendeeScannerController);
